export const API = {
  uploadFile: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/UploadFile`,
  uploadMyDocument: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/upload-mydocument`,
  uploadGroundedInGoodnessEvidence: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/upload-gig-evidence`,
  downloadMyDocument: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/download-mydocument?documentId=`,
  downloadFile: `${window.REACT_APP_API_GATEWAY_URL}/cms/api/Asset/DownloadFileByDocId?documentId=`,
  downloadFileByName: `${window.REACT_APP_API_GATEWAY_URL}/portal/api/Asset/DownloadFileByFileName?fileName=`,
  uploadImage: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/Asset/upload-image`,
  saveLogWhenUserLoginErrors: `${window.REACT_APP_API_GATEWAY_URL}/personal/api/personal-data/Producer/SaveLogWhenUserLoginErrors`,
  switchAccount: `${window.REACT_APP_IDENTITY_URL}/api/linkedAccount/switchAccount`
};
